var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#515864",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.501 3.667c0-.132.112-.238.25-.238H15v3.81h4.499v13.094a.244.244 0 01-.25.238H4.75a.244.244 0 01-.25-.238V3.667zM15 2h.719a1.8 1.8 0 011.22.47l3.53 3.26c.34.315.531.746.531 1.197v13.406c0 .92-.784 1.667-1.752 1.667H4.752C3.784 22 3 21.254 3 20.333V3.667C3 2.747 3.784 2 4.751 2H15zm-3.646 7.434v6.225L8.9 13.277l-.9.927 3.55 3.446h.9L16 14.204l-.9-.927-2.454 2.382V9.434h-1.293z"
  })));
}
export default SvgDownload;